import creditCardType from 'credit-card-type';

creditCardType.addCard({
  niceType: 'Mada',
  type: 'mada',
  patterns: [
    636120,
    417633,
    468540,
    468541,
    468542,
    468543,
    446393,
    400861,
    409201,
    458456,
    484783,
    462220,
    455036,
    486094,
    486095,
    486096,
    504300,
    440533,
    489318,
    489319,
    445564,
    432328,
    428671,
    428672,
    428673,
    446672,
    543357,
    529415,
    535825,
    543085,
    524130,
    554180,
    549760,
    524514,
    529741,
    537767,
    535989,
    536023,
    513213,
    588982,
    589005,
    508160,
    531095,
    530906,
    532013,
    422817,
    422818,
    422819,
    428331,
    483010,
    483011,
    483012,
    589206,
    588845,
    588846,
    636120,
    588847,
    588848,
    504300,
    432328,
    588850,
    588849,
    585265,
    588851,
    589206,
  ],
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: 'CVV',
    size: 3,
  },
});

const availableCards = ['visa', 'mastercard', 'mada'];

export const findTypeByNumber = (cardNumber) => {
  const card = creditCardType(cardNumber).filter(
    card => availableCards.indexOf(card.type) !== -1,
  )[0];

  return card || null;
};
